import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-admin',
  templateUrl: './content-admin.component.html',
  styleUrls: ['./content-admin.component.css']
})
export class ContentAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
